import React from 'react';
import { formatFieldName, formatValue } from '../../utils/formatters';

const DNSSection = ({ dnsAnswers }) => {
    if (dnsAnswers.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>DNS</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {dnsAnswers.map(([field, value]) => {
                    const isErrorField = field === 'dns_errors';
                    return (
                        <div
                            key={field}
                            style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '6px',
                                padding: '15px',
                                gridColumn: isErrorField ? '1 / -1' : undefined
                            }}
                        >
                            <div style={{
                                fontSize: '12px',
                                color: '#a0a0a0',
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                {formatFieldName(field)}
                            </div>
                            <div style={{
                                fontSize: isErrorField ? '14px' : '18px',
                                fontWeight: isErrorField ? '500' : 'bold',
                                color: '#e0e0e0',
                                lineHeight: isErrorField ? '1.6' : '1.2',
                                whiteSpace: isErrorField ? 'pre-wrap' : 'normal'
                            }}>
                                {formatValue(value)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DNSSection;






